import LogRocket from 'logrocket';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Sentry from '@saucelabs/sl-util-sentry';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { logRocketID } from '@saucelabs/sl-util-config';

const initLogRocket = () => LogRocket.init(logRocketID, {
  mergeIframes: true,
  shouldCaptureIP: false,
  dom: {
    inputSanitizer: true,
  },
  network: {
    requestSanitizer: (request) => {
      // eslint-disable-next-line no-param-reassign
      request.body = undefined;
      return request;
    },
    responseSanitizer: (response) => {
      // eslint-disable-next-line no-param-reassign
      response.body = undefined;
      return response;
    },
  },
});

if (logRocketID && navigator.userAgent.indexOf('PD-TESTS') === -1) {
  initLogRocket();
  LogRocket.getSessionURL((sessionURL) => {
    Sentry.configureScope((scope) => {
      scope.setExtra('sessionURL', sessionURL);
    });
  });
}

export default LogRocket;
